import * as yup from "yup";
import { MIN_STRING_LENGTH, MAX_TITLE_LENGTH, ALLOWED_SYMBOLS_REGEX, MIN_ITEMS_QUANTITY } from "../constants";


export const initialValues = {
  organisationLogoMobile: "",
  primaryColorMobile: "",
  secondaryColorMobile: ""
};

export const validationSchema = yup.object().shape({
  primaryColorMobile: yup
    .string()
    .min(MIN_STRING_LENGTH)
    .max(MAX_TITLE_LENGTH)
    .required("Is required"),
  secondaryColorMobile: yup
    .string()
    .min(MIN_STRING_LENGTH)
    .max(MAX_TITLE_LENGTH)
    .required("Is required"),
  organisationLogoMobileWidth: yup.number()
    .typeError('Width must be a number')
    .min(120, 'Minimum is 120px')
    .max(160, 'Maximum is 160px')
    .required('Width is required'),
  organisationLogoMobileHeight: yup.number()
    .typeError('Height must be a number')
    .min(32, 'Minimum is 32px')
    .max(48, 'Maximum is 48px')
    .required('Height is required'),
  CONTACT_US_WEBSITE: yup
    .string()
    .matches(
      /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i,
      'Invalid website URL'
    )
    .nullable(),
  CONTACT_US_EMAIL: yup
    .string()
    .email('Invalid email address')
    .nullable(),
  CONTACT_US_LINKEDIN: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?linkedin\.com\/.+$/i,
      'Invalid LinkedIn URL'
    )
    .nullable(),
  CONTACT_US_FB: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?facebook\.com\/.+$/i,
      'Invalid Facebook URL'
    )
    .nullable(),
  CONTACT_US_INSTAGRAM: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i,
      'Invalid Instagram URL'
    )
    .nullable(),
  CONTACT_US_TIKTOK: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?tiktok\.com\/.+$/i,
      'Invalid TikTok URL'
    )
    .nullable(),
  CONTACT_US_TWITTER: yup
    .string()
    .matches(
      /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.+$/i,
      'Invalid Twitter/X URL'
    )
    .nullable(),
  mobileSignUpLogoWidth: yup.number()
    .typeError('Width must be a number')
    .min(30, 'Minimum is 30px')
    .max(48, 'Maximum is 48px')
    .required('Width is required'),
  mobileSignUpLogoHeight: yup.number()
    .typeError('Height must be a number')
    .min(30, 'Minimum is 30px')
    .max(48, 'Maximum is 48px')
    .required('Height is required'),
});